import axios from 'axios';
import { API_URL } from '../config/api';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: token ? `Bearer ${token}` : '' };
};

export const fetchRelationshipWith = async (userId) => {
  try {
    const response = await axios.get(`${API_URL}/relationships/with/${encodeURIComponent(userId)}`, {
      headers: authHeaders(),
    });
    return response.data || null;
  } catch (err) {
    if (err.response?.status === 204 || err.response?.status === 404) {
      return null;
    }
    throw err;
  }
};

export const saveRelationshipWith = async (userId, body) => {
  const response = await axios.put(
    `${API_URL}/relationships/with/${encodeURIComponent(userId)}`,
    body,
    { headers: authHeaders() },
  );
  return response.data;
};

export const deleteRelationshipWith = async (userId) => {
  await axios.delete(`${API_URL}/relationships/with/${encodeURIComponent(userId)}`, {
    headers: authHeaders(),
  });
};

export const fetchPendingRelationshipNudges = async () => {
  const response = await axios.get(`${API_URL}/relationships/nudges/pending`, {
    headers: authHeaders(),
  });
  return Array.isArray(response.data) ? response.data : [];
};

export const dismissRelationshipNudge = async (userId) => {
  await axios.post(`${API_URL}/relationships/nudges/dismiss/${encodeURIComponent(userId)}`, {}, {
    headers: authHeaders(),
  });
};
